import switchGame from './switchGame'
import formSaveHandler from './formSaveHandler'

const customSagas = [
  formSaveHandler,
  switchGame,
]

export default customSagas
